import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ListItem} from "../../../../../objects/listItem";
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {DialogCanvasComponent} from "../../../../dialog-canvas/dialog-canvas.component";
import {AppComponent} from "../../../../../app.component";
import {AppEvent} from "../../../../../objects/appEvent";
import {SharedDataService} from "../../../../../services/shared-data.service";
import {SubscriptionLike} from "rxjs";

@Component({
  selector: 'app-cup-player-item',
  templateUrl: './cup-player-item.component.html',
  styleUrls: ['./cup-player-item.component.css']
})
export class CupPlayerItemComponent implements OnInit {
  @Input() listItem: ListItem;

  constructor(public application: AppComponent,
              public sharedDataService: SharedDataService,
              public confirmationDialog: MatDialog,
              public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  public clickOnItemMenu(event: MouseEvent): void {
    event?.stopImmediatePropagation()
  }

  public clickMenu(menuAction) {
    //todo: dispatch AppEvent with player menu action
  }

  public clickOnItem(event) {
    //if(this.application.user.id == this.listItem.itemFullData['id']) return;
    let appEvent = new AppEvent(AppEvent.CUP_PLAYER_VIEW_OPEN, {player_id: this.listItem.itemFullData['id']});
    this.sharedDataService.pushAppEvent(appEvent);
    return;
    // const commonDialogConf = {
    //   minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
    //   height: 'auto',
    // }
    // const dialogRef = this.dialog.open(DialogCanvasComponent, {
    //   minWidth: this.application.layoutMatches['isHandsetDefaultLayout'] ? '95%' : '65%',
    //   height: 'auto',
    //   data: {
    //     application: this.application,
    //     state: 'cup-player-info-popup',
    //     payload: {item: this.listItem, listPayload: this.listPayload},
    //   }
    // } as MatDialogConfig);
    // dialogRef.addPanelClass('common-dialog');
    // dialogRef.addPanelClass('common-dialog-medium-form');
    // dialogRef.afterOpened().subscribe(() => {
    //   (dialogRef.componentInstance as DialogCanvasComponent).isOpened = true;
    // })
    // dialogRef.afterClosed().subscribe(() => {
    //   // let appEvent = new AppEvent(AppEvent.CUP_PLAYER_VIEW_CLOSE, {player_id: this.listItem.itemFullData['id']});
    //   // this.sharedDataService.pushAppEvent(appEvent);
    // })
  }
}
